import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";

type Reporter = (metric: Metric) => void;

const consoleReporter: Reporter = (metric) => {
  console.debug(`[web-vitals] ${metric.name}=${metric.value.toFixed(2)} (${metric.rating})`);
};

export function initWebVitals(reporter: Reporter = consoleReporter): void {
  onCLS(reporter);
  onFCP(reporter);
  onINP(reporter);
  onLCP(reporter);
  onTTFB(reporter);
}
